import { formatDate, CurrencyFormat } from "../../../../../components/helpers";

export const convertCapitalTransaction = (capitalTransactions) => {
  let convertedCapitalTransaction = [];

  if (!capitalTransactions) return [];

  capitalTransactions.forEach((transaction, index) => {
    convertedCapitalTransaction.push({
      key: index + 1,
      transactionID: transaction.transaction_id,
      entityID: transaction.entity_id,
      dateTime: formatDate(transaction.date_time) || "-",
      outletName: transaction.outlet_name || "-",
      gadaiCode: transaction.gadai_code || "-",
      customerName: transaction.customer_name || "-",
      officerName: transaction.officer_name || "-",
      transactionType: transaction.transaction_type || "-",
      amount: `Rp ${CurrencyFormat(transaction.amount) || 0}`,
      transactionMethod: transaction.transaction_method || "-",
    });
  });
  return convertedCapitalTransaction;
};
